/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#chart{height:440px;width:750px}.field[_ngcontent-%COMP%]{margin:1%}.centeredField[_ngcontent-%COMP%]{margin:1%;display:flex;justify-content:center;align-items:center}.reqIcon[_ngcontent-%COMP%]{color:red}.button[_ngcontent-%COMP%]{margin:1%}.ui.message[_ngcontent-%COMP%]{margin:1%;width:98%}\n/*# sourceMappingURL=profile-page.component.css.map*/"];
export { styles as styles };
